import { BaseModel } from "@/models/BaseModel";
import { Document } from "@/models/Document";
import { maxLength, required } from "vuelidate/lib/validators";

export class WhistleBlowerReport extends BaseModel {
  constructor({
    id = null,
    guid,
    what_and_why,
    how_info,
    who_involved,
    when_alerted,
    time_period,
    still_ongoing,
    more_people_aware,
    documentation_exists,
    documents = [],
    company,
    other,
    password,
    name,
    phone,
    email,
    anonymous_to_company,
    status,
    creation_date
  }) {
    super();
    (this.id = id), (this.guid = guid);
    this.what_and_why = what_and_why;
    this.how_info = how_info;
    this.who_involved = who_involved;
    this.when_alerted = when_alerted;
    this.time_period = time_period;
    this.still_ongoing = still_ongoing;
    this.more_people_aware = more_people_aware;
    this.documentation_exists = documentation_exists;
    this.documents = documents;
    this.company = company;
    this.other = other;
    this.password = password;
    this.name = name;
    this.phone = phone;
    this.email = email;
    this.anonymous_to_company = anonymous_to_company;
    this.status = status;
    this.creation_date = creation_date;
  }
  static get validations() {
    const validations = {
      what_and_why: {
        maxLength: maxLength(1000),
        required
      },
      how_info: {
        maxLength: maxLength(1000),
        required
      },
      who_involved: {
        maxLength: maxLength(1000),
        required
      },
      when_alerted: {
        maxLength: maxLength(255),
        required
      },
      time_period: {
        maxLength: maxLength(255),
        required
      },
      still_ongoing: {
        maxLength: maxLength(255),
        required
      },
      more_people_aware: {
        maxLength: maxLength(255),
        required
      },
      documentation_exists: {
        maxLength: maxLength(255),
        required
      },
      other: {
        maxLength: maxLength(1000),
        required
      },
      password: {
        maxLength: maxLength(255),
        required
      },
      name: {
        maxLength: maxLength(255)
      },
      phone: {
        maxLength: maxLength(255)
      },
      email: {
        maxLength: maxLength(255)
      },
      anonymous_to_company: {
        required
      }
    };

    return validations;
  }
}

export default WhistleBlowerReport;
